<template>
    <div class="one-content" v-if="!video && newsList">

            <div class="text">
                <div class="text-h" v-if="newsList[0]">
                    <img v-if="!this.isImages" :src="newsList[0].image" vspace="0" hspace="0" align="right" >
                    <div v-else class="no_images" vspace="0" hspace="0" align="right"></div>
                    <h3 class="no_upper">{{newsList[0].title}}</h3>
                    <div v-html="newsList[0].text"></div>
                    <div v-if="entry && show" v-html="entry.text"></div>
                </div>
                <a href="#" class="more text-black solid" @click.prevent="more(newsList[0].id,$event)">
                  <span v-if="!this.show">Свернуть текст</span>
                  <span v-if="entry && this.show">Закрыть текст</span>
                </a>
            </div>

        <div class="content-video" v-if="video">

        </div>
    </div>
</template>

<script>
    import NewsItemMixin from "../mixins/NewItemMixin";

    export default {
        props: {
            video: Boolean,
        },
      mixins: [NewsItemMixin],
      data() {
        return {
           show: false,
           sizeImgError: '500x500',
           isImages: false,
        }
      },
      methods: {
        more(id,$event) {
         // console.log($event)
           this.show =  !this.show;
           this.$store.dispatch('content/loadSingle', { sID: 'news', ID: id });
        }
      },
      computed: {
        entry() {
          return this.$store.state.content.single.news;
        },
        newsList() {
          return this.$store.state.content.entities.news.items;
        },
      },
      mounted() {

          this.$store.dispatch('content/loadEntities', {sID: 'news'});

      },
    }
</script>

<style lang="scss" scoped>
   .one-content {
     .no_images {
       width: 58.6%;
       padding-bottom: 35%;
       background: $color-gray-3;
       margin-left: 15px;
       float: right;
     }
     padding-top: 20px;
      h3 {
          padding: 0 0 15px;
      }
       img {

           width: 60%;
           padding: 10px 0 10px 15px;
           @media (max-width: $media_xs) {
               width: 100%;
               padding: 0px 0px 20px 0px;
           }

       }
       .text {
           padding-bottom: 60px;
           @media (max-width: $media_xs) {
              font-size: 16px;
           }
       }
       .text-h {
           padding-bottom: 40px;
       }
       .content-video {
           width: 100%;
           height: 35vw;
           background:$color-gray;
       }
   }


</style>



// WEBPACK FOOTER //
// components/shared/content/ContentText.vue